import cleanedFilename from '~/util/cleanedFilename';

export default {
  LoadingAnimation: `${cleanedFilename(__filename)}-LoadingAnimation`,
};
